import React from "react"
import PropTypes from "prop-types"
import {findDOMNode} from "react-dom"
import SelectGenericPopoverOption from "./option/option"

const debug = false
// const debug = "SelectGenericPopoverOptionsSelector"

export default class SelectGenericPopoverOptionsSelector extends React.Component {

    static propTypes = {
        parent                  : PropTypes.object,

        options                 : PropTypes.array,

        searchString            : PropTypes.string,

        noValueOptionLabel      : PropTypes.string,
        noValueOption           : PropTypes.bool,   // is all values option available
        keyboardNavigation      : PropTypes.bool,
        scrollToSelected        : PropTypes.bool,

        popoverOptionComponent  : PropTypes.func,

        onUpdateScroll          : PropTypes.func,
    }

    static defaultProps = {
        keyboardNavigation  : true
    }

    constructor(props) {
        super(props)

        this.state = {
            currentCursorKey: null
        }

        // references for options for keyboard navigation
        this.optionRef = {}
    }

    componentDidMount() {
        debug && console.log(debug, "componentDidMount", this.props.scrollToSelected)
        if (this.props.scrollToSelected) {
            // setTimeout is required to call it on next frame for VScroll to finish rendering
            setTimeout(()=>{
                const node = this.selectedOptionRef ? findDOMNode(this.selectedOptionRef) : null
                if (node) this.props.onUpdateScroll(node, true)
            }, 0)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const node = this.optionRef[this.state.currentCursorKey] ? findDOMNode(this.optionRef[this.state.currentCursorKey]) : null

        // scroll for cursor to be visible
        if (node) this.props.onUpdateScroll(node)
    }

    _getOptions = () => {
        let options = this.props.options.slice()

        // filter options by search string
        let searchString = this.props.searchString
        if (searchString) {
            searchString = searchString.toLowerCase()
            options = _(options)
                .filter(option => option.label && option.label.toLowerCase().includes(searchString))
                .value()
        }

        // add all values if necessary
        if (this.props.noValueOption) {
            options.unshift({
                isNoValueOption     : true,
                label               : this.props.noValueOptionLabel
            })
        }

        return options;
    }

    onClickOption = (option) => {this.props.parent.onOptionClick(option)}

    onChangeCursorOption = (newValue) => {
        this.setState({currentCursorKey: newValue})
    }

    onPopoverKeyDown = (event) => {
        if (!this.props.keyboardNavigation) return

        const options = this._getOptions()

        let newValue

        switch(event.key) {
            case 'Escape':
                this.props.parent.hidePopover()
                break

            case 'ArrowUp':
                if (this.state.currentCursorKey === null) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey - 1;
                    if (newValue < 0) newValue = 0
                }

                this.onChangeCursorOption(newValue)
                break

            case 'ArrowDown':
                if (this.state.currentCursorKey === null) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey + 1
                    if (newValue > options.length - 1) newValue = options.length - 1
                }

                this.onChangeCursorOption(newValue)
                break

            case 'Enter':
                if (this.state.currentCursorKey !== null) {
                    const curOption = options[this.state.currentCursorKey]
                    if (curOption) this.onClickOption(curOption)
                }
                break
        }
    }

    _optionReference = (key, r, isSelected) => {
        this.optionRef[key] = r
        if (isSelected) this.selectedOptionRef = r
    }

    render() {
        const options = this._getOptions()
        const highlightedOption = options[this.state.currentCursorKey]
        const selectedOption = this.props.parent.state.currentOption

        const PopoverOption = this.props.popoverOptionComponent || SelectGenericPopoverOption

        debug && console.log(debug, "render", options)

        return (
            <React.Fragment>
                {_.map(options, (option, key)=> {
                    const isSelected = selectedOption && selectedOption.value === option.value
                    return <PopoverOption ref              = {r=>this._optionReference(key, r, isSelected)}
                                          key              = {"{0}_{1}".f(key, option.isNoValueOption ? 'all_values' : option.value)}
                                          option           = {option}
                                          isHighlighted    = {highlightedOption && highlightedOption.value === option.value}
                                          isSelected       = {isSelected}
                                          onClick          = {()=>this.onClickOption(option)}/>
                })}
            </React.Fragment>
        )
    }
}